import "../../index.css";
import {
  BottomContainer,
  HeaderContainer,
  RectanglesContainer,
  Bookmark,
  StyledHeader,
  BackgroundBanner,
  UpperContainer,
  WelcomePageWrapper,
  FooterLogos,
  FlagIcon,
} from "./WelcomePage.style";
import Button from "../../components/Button";
import Information from "../../components/Information";
import { useState } from "react";
import GameRulesModal from "../../components/Modals/GameRulesModal";
import WelcomePageTextBackground from "../../assets/Logo_v2.svg";
import BookmarkImage from "../../assets/Bookmark.svg";
import FooterLogosImg from "../../assets/footer-logos.svg";
import PlayImg from "../../assets/play-btn.png";


const WelcomePage = () => {
  let [open, setOpen] = useState(false);

  return (
    <WelcomePageWrapper>
      <GameRulesModal handleClose={setOpen} open={open} />
      <UpperContainer>
        {" "}
        <RectanglesContainer>
          <Bookmark src={BookmarkImage} />
        </RectanglesContainer>
        <Information handleClick={setOpen} open={open} />
      </UpperContainer>

      <HeaderContainer>
        {" "}
        <BackgroundBanner src={WelcomePageTextBackground} />
        
        <Button url="/login" imgurl={PlayImg} margin="230px 0 0 0" />
      </HeaderContainer>
      <BottomContainer>
        <FooterLogos src={FooterLogosImg} />
      </BottomContainer>
    </WelcomePageWrapper>
  );
};

export default WelcomePage;
